<template>
	<div>
		<label class="pre-inline">{{pre_item.name}}:</label>
		<input class="pre-input " type="text" :class="[pre_item.class!=''?pre_item.class:'short']"
			v-model="pre_sel_name" :placeholder="pre_item.note" @change="fun_change" />
		<el-select v-show="dataHas" v-model="pre_sel_name" clearable class="pre-inline"
			:class="[pre_item.class!=''?pre_item.class:'short']" placeholder="待选" @change="choseValue">
			<el-option v-for="item in pre_list_data" :key="item.id" :label="item.val" :value="item.id">
			</el-option>
		</el-select>

		<em class="pre-em"  v-show="pre_item.w=='1'">*</em><em class="pre-em"  v-show="pre_item.w=='0'">&nbsp;&nbsp;</em>
	</div>
</template>

<script>
	//
	import api from '@/utils/type.js';

	import {
		Method_EasySelect
	} from '@/utils/loadhttpdata.js';

	export default {
		name: "hj-select",
		data() {
			return {
				pre_item: {},
				is_active: false,

				pre_api_action: '',
				pre_list_data: [],
				pre_list_bak: [],
				pre_sel_val: '',
				pre_sel_name: '',
				dataHas: true,
				dataNo: false,

			}
		},
		props: {
			inData: {
				type: String,
				default: ''
			}
		},
		watch: {
			inData(val) {
				if (typeof(val) !== 'undefined' && val != '') {
					this.init(val);
				}
			}
		},
		created() {
			// console.log('hj-select 组件创建时调用 创建');
			this.init_select();
		},
		// mounted: function() {
		//   console.log('hj-select 组件加载时调用 mounted');
		//   this.init_select();
		// },
		activated: function() {
			// console.log('hj-select 组件激活时调用 激活');
			this.init_select();
		},
		deactivated: function() {
			// console.log('hj-select 组件激活时调用 停用');
			this.pre_item = {};
			this.pre_list_bak = [];
			this.pre_list_data = [];
			this.pre_sel_name = '';
			this.pre_sel_val = '';

			this.is_active = false;
		},
		methods: {
			init_select: function() {
				// console.log('hj-select 组件初始化 is_active='+this.is_active);
				if (!this.is_active) {
					this.pre_item = {};
					this.pre_item = JSON.parse(this.inData);
					// console.log(this.pre_item);

					this.pre_api_action = '';
					this.pre_api_action = this.pre_item.sel_action;
					if (typeof(this.pre_api_action) !== 'undefined' && this.pre_api_action != '') {
						this.loaddata();
					} else {
						this.pre_list_data = this.pre_item.list;
						this.pre_list_bak = this.pre_item.list;
					}
					this.is_active = true;
				}
			},
			init: function(parm) {

				let r = JSON.parse(parm);
				// console.log('select检测', r);
				this.pre_item = {};
				this.pre_item = r;
				this.pre_sel_name = '';
				this.pre_sel_val = ''; //置空，不然会 误导

				let id = 0;
				let temp_name = '';
				let is_go = true;
				id = r.val;
				temp_name = r.sel_name;
				// 更新列表
				if (typeof(r.list)!=='undefined' && r.list.length > 0) {
				  this.pre_list_data = r.list;
				  this.pre_list_bak = r.list;
				}
				// console.log('检测 id=' + id + ' temp_name=' + temp_name);
				if (Number(id) == 0 && temp_name == '') {
					this.val_back();
				}

				if (Number(id) > 0) {
					for (let j = 0; j < this.pre_list_data.length; j++) {
						if (this.pre_list_data[j].id == id) {
							this.pre_item.val = this.pre_list_data[j].id;
							this.pre_sel_name = this.pre_list_data[j].val;
							is_go = false;
							break;
						}
					}
				}

				if (is_go == true && temp_name != '') {
					// console.log(this.pre_list_data)
					for (let j = 0; j < this.pre_list_data.length; j++) {
						if (this.pre_list_data[j].val == temp_name) {
							this.pre_item.val = this.pre_list_data[j].id;
							this.pre_sel_name = this.pre_list_data[j].val;
							break;
						}
					}
					// console.log(this.pre_sel_name)
					// console.log(this.pre_item);
				}


				// console.log(this.pre_item);

				// this.val_back();
			},
			loaddata: function() {
				this.pre_list_data = [];
				this.pre_list_bak = [];
				this.$post(
					api.http_method, Method_EasySelect(this.pre_api_action)
				).then(res => {
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == '1') {
						this.pre_list_data = res.data.data;
						this.pre_list_bak = res.data.data;
					} else {
						this.$message({
							type: 'info',
							message: res.msg
						});
					}
				});

			},
			val_back: function() {
				this.$emit('com-event', this.pre_item);
			},
			fun_change: function() {
				console.log('sel_name=' + this.pre_sel_name);
				console.log('默认sel_name=' + this.pre_item.sel_name);
				// console.log('展示list=' + this.pre_list_data.length)
				// console.log('备份list=' + this.pre_list_bak.length)

				let is_back = false;
				// 模糊查询
				if (typeof(this.pre_sel_name) != "undefined" && this.pre_sel_name != '') {

					// 模糊查询
					this.pre_list_data = [];
					for (let j = 0; j < this.pre_list_bak.length; j++) {
						if (this.pre_list_bak[j].val.indexOf(this.pre_sel_name) >= 0) {
							this.pre_list_data.push(this.pre_list_bak[j]);
						}
					}


					if (this.pre_list_data.length == 0) {
						for (let j = 0; j < this.pre_list_bak.length; j++) {
							if (this.pre_list_bak[j].val == this.pre_sel_name) {
								this.pre_sel_val = this.pre_list_bak[j].val;
								this.pre_sel_name = this.pre_list_bak[j].val;
								this.pre_item.val = this.pre_list_bak[j].id;
								is_back = true;
								break;
							}
						}
						this.pre_list_data = this.pre_list_bak;
						// console.log('回调标识=' + is_back)
						// console.log('备份list=' + this.pre_list_bak.length)
						// console.log('展示list=' + this.pre_list_data.length)
						// if (is_back) {
						// 	this.val_back();
						// }

					}

				}

			},
			choseValue: function(e) {
				this.pre_sel_name = '';
				this.pre_sel_val = '';
				// console.log(e);
				// console.log(this.pre_list_data);
				
				
				if(e==''){
					console.log('清理')
					this.pre_item.val = '';
					this.pre_item.sel_name = '';
				}else{
					for (let i = 0; i < this.pre_list_data.length; i++) {
						if (this.pre_list_data[i].id == e) {
							this.pre_sel_val = this.pre_list_data[i].val;
							this.pre_sel_name = this.pre_list_data[i].val;
							this.pre_item.val = e;
							this.pre_item.sel_name = this.pre_list_data[i].val;
							break;
						}
					}
				}
				
				// console.log('sel_name=' + this.pre_sel_name);
				this.val_back();
			}
		}
	}
</script>

<style scoped="scoped">
	.pre-inline {
		display: inline-block;
		vertical-align: middle;
		margin-right:2px;
		min-width: 108px;
	}

	.pre-input {
		display: inline-block;
		vertical-align: middle;

	}
	
	.pre-em {
		display: inline-block;
		vertical-align: middle;
		width: 5px;
	}
</style>
